export const BRAND_CARD_STATUS = Object.freeze({
  loading: "loading",
  resolved: "resolved",
  error: "error",
});

export function resolveBrandCard({ status, journey }) {
  if (status === BRAND_CARD_STATUS.loading) return { kind: "loading" };
  if (status === BRAND_CARD_STATUS.error) return { kind: "error" };
  if (status !== BRAND_CARD_STATUS.resolved || !journey) return { kind: "error" };

  return {
    kind: "resolved",
    hasBrandProfileV2: Boolean(journey.brand_profile_v2_id),
    hasVisualDNA: Boolean(journey.approval),
    brandName: journey.brand_profile_v2_id ? journey.brand_name?.trim() || "Твой бренд" : null,
    journey,
  };
}
